import { Component, OnInit, QueryList, ViewChildren, ViewChild } from '@angular/core';
import { HeaderData } from 'src/app/_models/header-data';
import { SubmissionsService } from '../_services/submissions.service';
import { SortEvent, SortableDirective } from 'src/app/_directives/sortable.directive';
import { SubmissionsCriteria } from './_models/submissions-criteria';
import { RESULTS_NOT_FOUND, SUBMISSION_MSGS, FORM_MSGS } from 'src/app/_common/product-config';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { Modules, StatusCode } from 'src/app/_common/_enum/module.enum';

export enum SubmissionView {
  MySubmissions = "My Submissions",
  AllSubmissions = "All Submissions"
}

@Component({
  selector: 'app-submissions',
  templateUrl: './submissions.component.html',
  styleUrls: ['./submissions.component.scss']
})
export class SubmissionsComponent implements OnInit {

  resultsNotFound = RESULTS_NOT_FOUND;
  submissionsMsgs = SUBMISSION_MSGS;
  formMsgs = FORM_MSGS;
/* 
  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData; */
  private selectedView: string = SubmissionView.MySubmissions;
  
  private criteria: SubmissionsCriteria;
  private loading: boolean = false;
  private hasError: boolean = false;
  private submissions = [];
  private submissionList = [];

  private loggedInProfile;
  private hasAccess:boolean = false;

  private _total$ = new BehaviorSubject<number>(0);

  @ViewChildren(SortableDirective) headers: QueryList<SortableDirective>;
  
  @ViewChild("chooseNicheAndProducerCodeModal", {static: false}) chooseNicheAndProducerCodeModal;
  
  constructor(private router: Router,private submissionService:SubmissionsService) { 
  }

  ngOnInit() {
    this.criteria = new SubmissionsCriteria();
    this.loggedInProfile = this.submissionService.getLoggedInProfile();

    this.fetchSubmissions();
  }

  get ModuleEnum(){
    return Modules;
  }
  get SubmissionViewEnum(){
    return SubmissionView;
  }
  fetchSubmissions(_selectedView = true){
    this.loading = true; 
    this.hasError = false;
    let submissionSubscription =  this.submissionService.fetchSubmissions().subscribe(response=>{
      this.submissions = response;
      this.loading = false; 
      this.hasError = false;
      this.hasAccess = true;
      this._total$.next(response.length);
      this.submissionList = response;
      /* this.submissions = JSON.parse(JSON.stringify(this.submissionList)); */
     
      this.filterMySubmissions(_selectedView);
      
      this.submissions = this.doSort(this.criteria.sortBy, this.criteria.sortOrder);
    }, error=>{
      this.loading = false;
      this.hasError = true;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });

    setInterval(()=>{
      this.submissionService.runningServices.push(submissionSubscription);      
    },100)
  }
  
  goToDetails(id, _showAttachments=false){
    this.router.navigate(["newbusiness/submissions/" + id], {state: {showAttachments: _showAttachments}});
  }
  filterMySubmissions(isMySubmission = true){
    this.selectedView = (isMySubmission)?this.SubmissionViewEnum.MySubmissions:this.SubmissionViewEnum.AllSubmissions;

    if(this.hasError){
      this.fetchSubmissions(isMySubmission);
    }else{
      if(this.selectedView == this.SubmissionViewEnum.MySubmissions)
        this.submissions = this.submissionList.filter(submission => {return submission.submittedEmail == this.loggedInProfile.email});
      else
        this.submissions = JSON.parse(JSON.stringify(this.submissionList)); 

      this.criteria.pageNo = 1;
      this._total$.next(this.submissions.length);
    }
  }
  
  getSubmissionStatus(status){
    if(status){
      let cls = status.toLowerCase();
      if(status.toLowerCase().includes("declined"))
        cls = "declined";
      else if(status.toLowerCase().includes("review"))
        cls = "in-review";
        
      return cls;
    }else{
      return "-";
    }
  }

  get total$() { return this._total$.asObservable(); }
  /* ***Sorting Code*** */
  compare(v1, v2) {
    return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
  }

  onSort({column, direction}: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    if (direction !== '') {
      this.criteria.sortOrder = direction;
      this.criteria.sortBy = column;
      this.criteria.pageNo = 1;

      console.log("Call WebAPI to sort " + column + " column in " + direction + " order");
      return this.doSort(column, direction);
    }
  }

  doSort(column, direction){
    return this.submissions.sort((a, b) => {
      const res = this.compare(a[column], b[column]);
      return direction === 'asc' ? res : -res;
    });
  }
  /* Sorting Code */

  onPageChange(){
    window.scrollTo(0, 0);
  }


  ngOnDestroy() {
    this.submissionService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}
